import { Action, createReducer, on } from '@ngrx/store';
import * as ReactivateAssetWizardActionsV26 from './actions';
import { State, initialState } from './state';

export const reactivateAssetWizardFeatureKey = 'reactivateAssetWizardV26';

const addProductWizardReducer = createReducer(
  initialState,

  on(ReactivateAssetWizardActionsV26.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
  })),
  on(ReactivateAssetWizardActionsV26.selectAssetServicesInit, (state, { initAssetServiceStep }) => ({
    ...state,
    initAssetServiceStep,
  })),
  on(ReactivateAssetWizardActionsV26.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(ReactivateAssetWizardActionsV26.selectDeskStep, (state, { deskStep }) => ({
    ...state,
    deskStep,
  })),
  on(ReactivateAssetWizardActionsV26.selectProductStep, (state, { productStep }) => ({
    ...state,
    productStep,
  })),
  on(ReactivateAssetWizardActionsV26.selectServiceStep, (state, { serviceStep }) => ({
    ...state,
    serviceStep,
  })),
  on(ReactivateAssetWizardActionsV26.deleteServiceStep, (state) => ({
    ...state,
    serviceStep: null,
  })),
  on(ReactivateAssetWizardActionsV26.selectAdditionalStep, (state, { addInfoStep }) => ({
    ...state,
    addInfoStep,
  })),
  on(ReactivateAssetWizardActionsV26.deleteAdditionalStep, (state) => ({
    ...state,
    addInfoStep: null,
  })),
  on(ReactivateAssetWizardActionsV26.exitReactivateAssetWizard, (state) => ({
    ...state,
    initStep: null,
    initAssetServiceStep: null,
    dueDatesStep: null,
    deskStep: null,
    productStep: null,
    serviceStep: null,
    addInfoStep: null,
    errorMessage: null,
  })),
  on(ReactivateAssetWizardActionsV26.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    initAssetServiceStep: null,
    dueDatesStep: null,
    deskStep: null,
    productStep: null,
    serviceStep: null,
    addInfoStep: null,
    errorMessage: null,
  })),
  on(ReactivateAssetWizardActionsV26.createNewReactivateAsset, (state, { newOrder }) => ({
    ...state,
    newOrder,
  })),
  on(ReactivateAssetWizardActionsV26.createNewOrderSuccess, (state, { response }) => ({
    ...state,
    newOrderResponse: response,
  })),
  on(ReactivateAssetWizardActionsV26.createNewOrderFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return addProductWizardReducer(state, action);
}
